<div class="lp-inventory-item-content">
  @for (content of contents(); track content.uid) {
    @if (content.dataType === 'ParagraphContentElement') {
      <div>
        @if ((content.header?.length ?? 0) > 0) {
          <h1 style="font-weight: bold">{{ content.header }}</h1>
        }
        <p>{{ content.text }}</p>
      </div>
    } @else if (content.dataType === 'ImageContentElement') {
      <div>
        <img [src]="content.image.url" />
      </div>
    } @else if (content.dataType === 'AudioContentElement') {
      <div>
        <audio controls style="width: 100%">
          <source [src]="content.audio.url" type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </div>
    }
  }
</div>
